import React from "react";
import _ from "lodash";
import classNames from "classnames";
import { Map } from "immutable";

import AppConstants from "../../constants/AppConstants";
import IDUtils from "../../utils/IDUtils";
import StyleUtils from "../../utils/StyleUtils";
import PropertyMaps from "../../constants/PropertyMaps";
import LinkStyle from "./LinkStyle";
import { gatherProps } from "../../utils/Merge/MergeUtils.mjs";
import { SHADOW_STYLE, TEXT_STYLE } from "../../constants/MergeConstants";

const { TEXT_STYLE_PROPS, TEXT_NESTED_STYLES_INLINE_LINK } = PropertyMaps;

class Text extends React.PureComponent {
  render() {
    let style = {
      width: "100%",
      height: "100%",
    };

    const { id, content = Map(), elem, layout, theme, isChildElement } = this.props;

    const elemProps = gatherProps(
      elem,
      layout,
      [TEXT_STYLE, ...TEXT_STYLE_PROPS, ...TEXT_NESTED_STYLES_INLINE_LINK, SHADOW_STYLE],
      true,
      theme,
    );

    const text = content.get("text");
    const baseStyle = elemProps.get("style");
    const domID = IDUtils.getDOMID("si_element", id); // Element IDs cannot start with a number
    const linkStyle = elemProps.getIn(["styles", "link"]);

    let linkTag = null;
    if (linkStyle) {
      linkTag = <LinkStyle id={domID} linkStyle={linkStyle} theme={theme} />;
    }

    const styleClass = StyleUtils.getStyleClass(baseStyle);
    const classes = classNames(styleClass);

    const inlineStyle = StyleUtils.getStyle(PropertyMaps.STYLE_PROPS_INLINE, elemProps, theme);
    style = _.merge(style, inlineStyle);

    const overflow = isChildElement
      ? AppConstants.TEXT_OVERFLOW_SINGLE_LINE_ELLIPSIS
      : elemProps.get("over");

    switch (overflow) {
      case AppConstants.TEXT_OVERFLOW_SINGLE_LINE:
        style.overflow = "hidden";
        style.whiteSpace = "nowrap";
        break;
      case AppConstants.TEXT_OVERFLOW_SINGLE_LINE_ELLIPSIS:
        style.overflow = "hidden";
        style.textOverflow = "ellipsis";
        style.whiteSpace = "nowrap";
        break;
      case AppConstants.TEXT_OVERFLOW_CROP:
        style.overflow = "hidden";
        break;
      default:
        break;
    }

    style = _.merge(style, StyleUtils.getShadowStyle(elemProps, theme, "text"));

    if (linkTag && !isChildElement) {
      return (
        <div style={{ width: "100%", height: "100%" }}>
          {linkTag}
          <div
            id={domID}
            style={style}
            className={classes}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </div>
      );
    }
    return (
      <div
        id={domID}
        style={style}
        className={classes}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }
}

export default Text;
